import { combineReducers } from '@reduxjs/toolkit'
import { connectRouter } from 'connected-react-router'
import { createBrowserHistory } from 'history'
import language from './languageSlice'
import auth from './authSlice'
import home from './homeSlice'
import courier from './courierSlice'
import dictionary from './dictionarySlice'
import logistics from './logisticsSlice'
import order from './orderSlice'
import serviceProvider from './serviceProviderSlice'
import senderAddressForm from './senderAddressSlice'
import recipientAddressForm from './recipientAddressSlice'
import address from './addressSlice'
import parcel from './parcelSlice'
import store from './storeSlice'

import config from './configSlice'
import common from './commonSlice'
import trackingSetting from './trackingSettingSlice'
import giveaway from './giveawaySlice'
import captcha from './captchaSlice'

const history = createBrowserHistory()
const reducers = {
  language,
  auth,
  home,
  courier,
  dictionary,
  logistics,
  order,
  serviceProvider,
  senderAddressForm,
  recipientAddressForm,
  address,
  parcel,
  store,
  config,
  common,
  trackingSetting,
  giveaway,
  captcha
}

const rootReducer = combineReducers({
  ...reducers,
  router: connectRouter(history),
})

export type RootState = ReturnType<typeof rootReducer>
export default rootReducer
